import React, { useCallback } from 'react'
import UnpaidOrderModal from './order'
import { useDispatch, useSelector } from 'react-redux'
import AbortOrderModal from '../../../../../../Elements/modal/order/AbortOrderModal'
import { setZReportSelectedOrder, setZReportShowAbortOrder, setZReportShowOrder, setZReportShowOrderData, setZReportShowPaymentMethod } from '../../../../../../../redux/action/zreport'
import { updateOrderCustomerThunk } from '../../../../../../../redux/thunk/order/updateOrderCustomer'
import OrderDataModal from '../../../../../../Elements/modal/order/OrderDataModal'
import { getGiftCouponsPayment, getGiftCouponsSum } from '../../../../../../../helper/getGiftCouponsPayment'
import { getPrepaidPayments, getPrepaidSum } from '../../../../../../../helper/getPrepaidPayments'
import ModalPayment from '../../../../../../Elements/cart/ModalPayment'
import PrintReceiptConfirmationModal from '../../../../../../Elements/modal/PrintReceiptConfirmationModal'
import { confirmOrderPaymentsThunk } from '../../../../../../../redux/thunk/order'
import { roundPrice } from '../../../../../../../helper'
import { selectUsername } from '../../../../../../../redux/selector/system'
import { setOrderStatusThunk } from '../../../../../../../redux/thunk/order/setOrderStatus'

const UnpaidOrderModals = React.memo(() => {
	const { showOrder, showOrderData, showPaymentMethod, showAbortOrder } = useSelector(store => store.zReport.orderModal)
	const selectedOrder = useSelector(store => store.zReport.selectedOrder)
	const username = useSelector(selectUsername)
	const dispatch = useDispatch()
	const qrCodePaymentSession = useSelector(state => state.cartPayment.qrCodePaymentSession)
	const paymentSessionLink = qrCodePaymentSession?.link

	const orderPayment = selectedOrder?.payments?.filter(item => item?.method === selectedOrder?.paymentMethod)
	const totalSum = selectedOrder?.totalPrice
	const prepaidPayments = getPrepaidPayments(selectedOrder)
	const totalSumWithoutPrepaid = roundPrice(totalSum - getPrepaidSum(selectedOrder))

	const closeModalPayment = () => {
		dispatch(setZReportShowPaymentMethod(false))
	}

	const handleSuccessPayment = () => {
		dispatch(setZReportSelectedOrder(null))
		closeModalPayment()
	}

	const handlePayment = async ({ paymentId, paymentMethod, tips = 0, giftCoupons: giftCouponsAsPayment, customer }) => {
		const isEcTerminalPayment = paymentMethod === 'EC_TERMINAL'
		const isGiftCouponPayment = paymentMethod === 'GIFT_COUPON'
		const isQrCodePayment = paymentMethod === 'QR_CODE'
		const isInvoicePayment = paymentMethod === 'INVOICE'
		const isTap2PayPayment = paymentMethod === 'TAP_TO_PAY'

		if (isInvoicePayment) {
			await dispatch(updateOrderCustomerThunk(selectedOrder.orderId, customer))
		}
		const paymentWithCoupons = getGiftCouponsPayment(giftCouponsAsPayment)
		const resentPayments = [...paymentWithCoupons, ...prepaidPayments]
		const giftCouponSum = getGiftCouponsSum(giftCouponsAsPayment)
		const orderPaymentId = (isEcTerminalPayment || isQrCodePayment || isTap2PayPayment) ? paymentId : orderPayment[0].id
		const paymentLink = isQrCodePayment ? paymentSessionLink : null
		const payments = isGiftCouponPayment ? resentPayments : [{ id: orderPaymentId, method: paymentMethod, total: roundPrice(totalSumWithoutPrepaid - giftCouponSum), link: paymentLink }, ...resentPayments]
		await dispatch(confirmOrderPaymentsThunk(selectedOrder.orderId, { payments, tips, printerMetaData: { userPrintRequest: { userName: username } } }, { module: selectedOrder?.module?.moduleType, businessScope: selectedOrder?.orderType, platformType: selectedOrder?.platformMetaData?.platformType }))

		if (!isEcTerminalPayment && !isTap2PayPayment) {
			closeModalPayment()
		}
	}

	const closeModalOrderData = () => {
		dispatch(setZReportShowOrderData(false))
	}

	const reOpenPaymentModal = useCallback(() => {
		dispatch(setZReportShowPaymentMethod(false))
	}, [dispatch])

	const closeAbortOrderModal = useCallback(() => {
		dispatch(setZReportShowAbortOrder(false))
		dispatch(setZReportShowOrder(true))
	}, [dispatch])

	const handleAbortOrder = useCallback(async (reason, reasonCode) => {
		await dispatch(setOrderStatusThunk(selectedOrder, 'ABORTED', reason, reasonCode))
		dispatch(setZReportShowAbortOrder(false))
	}, [dispatch, selectedOrder])

	return (
		<>
			{showOrder && <UnpaidOrderModal />}
			<AbortOrderModal isOpen={showAbortOrder}
											 close={closeAbortOrderModal}
											 onAbortOrder={handleAbortOrder} />
			<OrderDataModal order={selectedOrder}
											modalIsOpen={showOrderData}
											close={closeModalOrderData} />
			<ModalPayment isOpen={showPaymentMethod}
										closeModal={closeModalPayment}
										openModal={reOpenPaymentModal}
										handlePayment={handlePayment}
										remark={selectedOrder?.remark}
										totalSum={totalSumWithoutPrepaid}
										isDeferredPayment={true}
										updatePaymentMode={false}
										module={selectedOrder?.module?.moduleType}
										orderType={selectedOrder?.orderType}
										platformType={selectedOrder?.platformMetaData?.platformType}
										customerOrder={selectedOrder?.customer}
										resetCart={handleSuccessPayment}
										changeCalculatorIsNeeded={true} />
			<PrintReceiptConfirmationModal />
		</>
	)
})

UnpaidOrderModals.displayName = 'UnpaidOrderModals'
export default UnpaidOrderModals
